import { MARQUEE } from "../../data";

export default function Marquee() {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div data-testid="marquee-ribbon-container" className="relative border-y border-borderln bg-ink py-5 overflow-hidden">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((t, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8 font-serif text-2xl sm:text-3xl text-sand/90">
            {t}
            <svg className="w-5 h-5 text-gold shrink-0" viewBox="0 0 24 24" fill="currentColor">
              {[0, 60, 120, 180, 240, 300].map((deg) => (
                <ellipse key={deg} cx="12" cy="7" rx="2.6" ry="5" transform={`rotate(${deg} 12 12)`} opacity="0.85" />
              ))}
              <circle cx="12" cy="12" r="2" opacity="1" />
            </svg>
          </span>
        ))}
      </div>
    </div>
  );
}
